import { type OnboardingStatusDto } from "@crowdcoursing/api/openapi";
import { Chip } from "@mui/material";

export function OnboardingStatusChip({ status, testId }: { status: OnboardingStatusDto | undefined; testId: string }) {
  return (
    <Chip
      data-testid={testId}
      label={status?.name || "Not started"}
      size="small"
      sx={{
        bgcolor: status?.backgroundColor || "action.hover",
        color: status?.textColor || "text.primary",
        fontWeight: 600,
      }}
    />
  );
}
